export default __webpack_public_path__ + "static/media/fmd3.131de18d.jpeg";